import { Announce } from '@nv/components'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './Loader.module.scss'

export const Loader = () => {
  const { t } = useTranslation()
  return (
    <>
      <Announce title={t('main.loading')} setPageName={false} />
      <div className={styles['container']} aria-live='polite'>
        <div className={styles['loading-background']}>
          <div className={styles['loading']}>
            <div className={clsx(styles['square'], styles['square--1'])}></div>
            <div className={clsx(styles['square'], styles['square--2'])}></div>
            <div className={clsx(styles['square'], styles['square--3'])}></div>
            <div className={clsx(styles['square'], styles['square--4'])}></div>
            <div className={clsx(styles['square'], styles['square--5'])}></div>
          </div>
        </div>
      </div>
    </>
  )
}
